// extracted by mini-css-extract-plugin
export default {"container":"Breadcumb_container__X1tWF","item":"Breadcumb_item__xDXuA"};